import { formatISO } from 'date-fns'

import {
  CourierExchangeLoadDtoInput,
  DeliverTimeRangeType,
  FixedLoadDtoMinVehicleSize,
  PickupTimeRangeType,
  StopTimeRangeType,
} from 'generated/graphql'

const normalizePostLoadForm = (data): Partial<CourierExchangeLoadDtoInput> => {
  let readyAt
  let collectBy
  let deliverFrom
  let deliverBy

  switch (data.pickupTimeRange) {
    case PickupTimeRangeType.At:
      readyAt = formatISO(data.readyAt)
      collectBy = null
      break

    case PickupTimeRangeType.Before:
      collectBy = formatISO(data.collectBy)
      readyAt = null
      break

    case PickupTimeRangeType.Between:
      readyAt = formatISO(data.readyAt)
      collectBy = formatISO(data.collectBy)
      break

    default:
      break
  }

  switch (data.deliverTimeRange) {
    case DeliverTimeRangeType.Asap:
      deliverFrom = null
      deliverBy = null
      break

    case DeliverTimeRangeType.At:
      deliverFrom = formatISO(data.deliverFrom)
      deliverBy = null
      break

    case DeliverTimeRangeType.By:
      deliverBy = formatISO(data.deliverBy)
      deliverFrom = null
      break

    case DeliverTimeRangeType.Between:
      deliverFrom = formatISO(data.deliverFrom)
      deliverBy = formatISO(data.deliverBy)
      break

    default:
      break
  }

  const stopTimeDetails = data.stopTimeDetails?.map((stopTimeDetail) => {
    switch (stopTimeDetail.timeRange) {
      case StopTimeRangeType.Asap:
        return {
          timeRange: stopTimeDetail.timeRange,
          timeFrom: null,
          timeTo: null,
        }

      case StopTimeRangeType.Between:
        return {
          timeRange: stopTimeDetail.timeRange,
          timeFrom: formatISO(stopTimeDetail.timeFrom),
          timeTo: formatISO(stopTimeDetail.timeTo),
        }
    }
  })

  return {
    readyAt,
    collectBy,
    stopTimeDetails,
    deliverFrom,
    deliverBy,
  }
}

const toCXVehicleSize = (vehicleTypeId: number | null): FixedLoadDtoMinVehicleSize | null => {
  switch (vehicleTypeId) {
    case 1:
      return FixedLoadDtoMinVehicleSize.SVan
    case 2:
      return FixedLoadDtoMinVehicleSize.Swb
    case 3:
      return FixedLoadDtoMinVehicleSize.Lwb
    case 4:
      return FixedLoadDtoMinVehicleSize.Luton
    case 5:
      return FixedLoadDtoMinVehicleSize.Value_7_5T
    case 6:
      return FixedLoadDtoMinVehicleSize.Value_18T
    case 7:
      return FixedLoadDtoMinVehicleSize.Transit
    case 8:
      return FixedLoadDtoMinVehicleSize.Xlwb
    case 9:
      return FixedLoadDtoMinVehicleSize.Value_26T
    case 10:
      return FixedLoadDtoMinVehicleSize.Value_13_6M
    default:
      return null
  }
}

export { normalizePostLoadForm, toCXVehicleSize }
